import OverlayTips from "../OverlayTips";

function CPPageOverlayTipsManager()
{
    PageOverlayTipsManager.call(this);
}

CPPageOverlayTipsManager.prototype = _.create(PageOverlayTipsManager.prototype, {
    addBaseTips: function()
    {
        PageOverlayTipsManager.prototype.addBaseTips.apply(this);

        this.add($(".pagetitle").first().find("span"), {
            messageKey: "tips.cp.title",
            direction: OverlayTips.DIRECTION_TOP_LEFT,
            offsetX: 10,
            offsetY: -10,
            outside: {
                direction: OverlayTips.DIRECTION_TOP_RIGHT
            }
        });
        var $cpNameCell = $(".cpNameCell").eqOrLast(3);
        if ($cpNameCell.length > 0)
        {
            this.add($cpNameCell, {
                messageKey: "tips.cp.edit",
                direction: OverlayTips.DIRECTION_TOP_LEFT,
                outside: {
                    direction: OverlayTips.DIRECTION_TOP_RIGHT,
                    offsetX: -200
                }
            });

            this.add($cpNameCell.parent().find(".spentCell"), {
                messageKey: "tips.cp.time_spent",
                direction: OverlayTips.DIRECTION_TOP_RIGHT
            });
        }

        this.add($(".listbuttonpane"), {
            messageKey: "tips.cp.buttons",
            direction: OverlayTips.DIRECTION_TOP_RIGHT,
            offsetY: -15
        });
    }
});

export default CPPageOverlayTipsManager;


// WEBPACK FOOTER //
// ./web/js/tips/managers/CPPageOverlayTipsManager.js